'use client';

import { useEffect } from 'react';

export default function AdsScript() {
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    const load = () => {
      timer = setTimeout(() => {
        if (document.getElementById('adsense-script')) return;
        const script = document.createElement('script');
        script.id = 'adsense-script';
        script.async = true;
        script.crossOrigin = 'anonymous';
        script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1744433413233959';
        document.head.appendChild(script);
      }, 1);
    };
    if (document.readyState === 'complete') load();
    else window.addEventListener('load', load, { once: true });
    return () => { window.removeEventListener('load', load); clearTimeout(timer); };
  }, []);
  return null;
}
